import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { PlanningDetails } from '../planning-details.dto';
import { GasExtinguishingSystemDesign } from './gas-extinguishing-system-design.dto';

export class InspectionGasExtinguishingSystemDto extends InspectionCase {
  gasExtinguishingSystemDesign?: GasExtinguishingSystemDesign;
  planningDetails?: PlanningDetails;
  summaryNotes?: SummaryNotes[];
}

export class InspectionGasExtinguishingSystem
  extends InspectionGasExtinguishingSystemDto
  implements Inspection
{
  constructor(
    data: InspectionGasExtinguishingSystemDto = {
      title: 'בדיקת מערכת כיבוי באמצעות גז',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);
    this.summaryNotes = data.summaryNotes;
    this.planningDetails = new PlanningDetails(data.planningDetails);
    this.gasExtinguishingSystemDesign = new GasExtinguishingSystemDesign(
      data.gasExtinguishingSystemDesign
    );
  }

  setInspectionStatus(): void {
    this.gasExtinguishingSystemDesign.setInspectionStatus();

    this.isPassed = this.gasExtinguishingSystemDesign.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.gasExtinguishingSystemDesign.getNotes()];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.gasExtinguishingSystemDesign.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.gasExtinguishingSystemDesign.title,
        cases: [
          this.gasExtinguishingSystemDesign.main,
          this.gasExtinguishingSystemDesign.areas[0].gasExtinguishingSystem,
          this.gasExtinguishingSystemDesign.areas[0].gasIndoorTest,
          this.gasExtinguishingSystemDesign.areas[0].gasActivationTest
        ]
      }
    ];
  }
}
